import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const Next: FC<IconSvgProps> = ({ clss }) => {
    const styles = {
        svg: {
            verticalAlign: 'middle',
            overflow: 'hidden',
        },
    };

    return (
        <svg style={{ ...styles.svg }} className={clss} width="87" height="86" viewBox="0 0 87 86">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-1314.000000, -6173.000000)">
                    <g transform="translate(1314.650967, 6173.504520)">
                        <path d="M0,85.99096 L21.2807559,0 L86.6980668,0 L65.0571856,85.99096 L0,85.99096 Z" id="Combined-Shape" fill="#C9CED1"></path>
                        <g transform="translate(31.277421, 36.116203)" fill="#000D44">
                            <path
                                d="M7.80162093,-0.761212329 L1.95414131,3.59394029 C1.65798367,3.82569663 1.631842,4.22170443 1.86264546,4.47368112 C2.09344892,4.72565781 2.55677568,4.76485418 2.83539089,4.55611794 L7.55430694,1.04679817 L7.55430694,14.0344854 C7.55430694,14.3779203 7.86250351,14.6566501 8.24224571,14.6566501 C8.62233189,14.6566501 8.93018449,14.3779203 8.93018449,14.0344854 L8.93018449,1.04679817 L13.6491005,4.55611794 C13.9277157,4.76485418 14.3876028,4.72285807 14.621846,4.47368112 C14.868472,4.21050547 14.8093093,3.80236545 14.5303501,3.59394029 L8.6828705,-0.761212329 C8.34853226,-0.955638785 8.09674666,-0.930130034 7.80162093,-0.761212329"
                                id="Fill-1"
                                transform="translate(8.242764, 6.879508) rotate(-270.000000) translate(-8.242764, -6.879508) "
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default Next;
